import { isiOS } from './util';

export function isPC(): boolean {
  if (isiOS()) {
    return false;
  }

  const isPCResult = !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent);
  return isPCResult;
}
